'use client';

import { getDefaultImgAlt } from '@core/Components/HeycarImage/GetDefaultImgAlt';
import { HeycarImage } from '@core/Components/HeycarImage/HeycarImage';
import { heycarLoader } from '@core/Components/HeycarImage/HeycarLoader';
import { IMAGE_SIZES } from '@core/Constants/ImageCarousel.constants';
import type { VehicleImage } from '@core/Entities/Vehicle/VehicleImage.entity';
import { getImgLoader } from '@core/Utils/Image/GetImgLoader';

import styles from './VehicleHeroImage.module.css';

export const VehicleHeroImage = ({
  image,
  index,
  makeModelLabel,
  isInactive,
  preloadLimit,
}: {
  image: VehicleImage;
  index?: number;
  makeModelLabel: string;
  isInactive?: boolean;
  preloadLimit?: number;
}) => {
  const mainImgString = getDefaultImgAlt();
  const loader = getImgLoader(image, heycarLoader);

  return (
    <HeycarImage
      src={image?.url}
      alt={image?.altText || `${mainImgString} - ${makeModelLabel}`}
      className={styles.img}
      sizes={IMAGE_SIZES.small}
      loader={loader}
      forceVisible={(index ?? 100) <= 1}
      preload={preloadLimit ? (index ?? 100) < preloadLimit : true}
      isInactive={isInactive}
    />
  );
};
